module.exports = __webpack_public_path__ + "img/close-video.bdd5936c.svg";